import _ from 'lodash'

import { Employee } from '@/model/companyStructure/Employee'
import { PlanningGroup } from '@/model/companyStructure/PlanningGroup'
import { EmployeeEvent } from '@/model/planning/EmployeeEvent'
import { SchedulerResourceEnum } from '@/types/enums'
import i18n from '@/i18n'
import { EmployeeCapacity } from '@/model/planning/EmployeeCapacity'

export class EmployeeResource {
  public type = SchedulerResourceEnum.Employee

  private constructor (
    readonly id: number,
    readonly fullName: string,
    readonly planningGroupName: string,
    readonly eventList: Array<EmployeeEvent>,
    readonly IST: string,
    readonly plan: string,
    readonly MGAZ: string,
    readonly MGAZColor: string,
    readonly note: string,
    readonly capacity?: string,
    readonly capacityType?: number | undefined,
    readonly position?: number | null
  ) {}

  public get hasEmptySchedule (): boolean {
    return this.eventList.length === 0
  }

  public static createListFromConfiguration (
    employeeList: Array<Employee>,
    planningGroupList: Array<PlanningGroup>,
    eventList: Array<EmployeeEvent>
  ): Array<EmployeeResource> {
    const list: Array<EmployeeResource> = employeeList.map((item: Employee) => {
      const planningGroup: PlanningGroup | undefined | any = _.find(planningGroupList, {
        planningGroup: item.planningGroupId
      })

      const employeeEventList = eventList.filter((eventItem: EmployeeEvent) => eventItem.employeeId === item.id)

      return new EmployeeResource(
        item.id,
        item.fullName,
        planningGroup ? planningGroup.planningGroupName : i18n.t('planningPage.planingGroupMissing').toString(),
        employeeEventList,
        '',
        '',
        '',
        '#000',
        item.note,
        '',
        undefined,
        item.position
      )
    })

    return list
  }

  public static createFloaterList (
    employeeList: Array<Employee>,
    planningGroupList: Array<PlanningGroup>,
    eventList: Array<EmployeeEvent>
  ): Array<EmployeeResource> {
    const list: Array<EmployeeResource> = employeeList.map((item: Employee) => {

      const employeeEventList = eventList.filter((eventItem: EmployeeEvent) => eventItem.employeeId === item.id)

      return new EmployeeResource(
        item.id,
        item.fullName,
        i18n.t('planningPage.floater').toString(),
        employeeEventList,
        '',
        '',
        '',
        '#000',
        item.note,
        '',
        undefined,
        1
      )
    })

    return list
  }

  public static createListWithCapacity (employeeList: Array<EmployeeResource>, employeeCapacityList: Array<EmployeeCapacity>) {
    const list = employeeList.map((item: EmployeeResource) => {
      const foundCapacity = employeeCapacityList.find((i: EmployeeCapacity) => i.id === item.id)
      return new EmployeeResource(
        item.id,
        item.fullName,
        item.planningGroupName,
        item.eventList,
        foundCapacity ? foundCapacity.ist : '',
        foundCapacity ? foundCapacity.plan : '',
        foundCapacity ? parseFloat(foundCapacity.MGAZ) ? parseFloat(foundCapacity.MGAZ).toFixed(2) : foundCapacity.MGAZ : '',
        foundCapacity ? foundCapacity.MGAZColor : '#000',
        item.note,
        foundCapacity ? foundCapacity.capacity : '',
        foundCapacity ? foundCapacity.type: undefined,
        item.position
      )
    })
    return list
  }

  public static createListWithEmptyCapacity (employeeList: Array<EmployeeResource>) {
    const list = employeeList.map((item: EmployeeResource) => {
      return new EmployeeResource(
        item.id,
        item.fullName,
        item.planningGroupName,
        item.eventList,
        '',
        '',
        '',
        '#000',
        item.note,
        '',
        undefined,
        item.position
      )
    })
    return list
  }

  public static createAvatar (eventList: Array<EmployeeEvent>, selectedDepartmentId: number) {
    const employeeEventList = eventList.filter((eventItem: EmployeeEvent) => eventItem.employeeId === 0 && eventItem.department == selectedDepartmentId)
    if (employeeEventList.length > 0) {
      return new EmployeeResource(
        0,
        '',
        i18n.t('planningPage.positionsNotAssigned').toString(),
        employeeEventList,
        '',
        '',
        '',
        '#000',
        ''
      )
    } else {
      return new EmployeeResource(
        0,
        '',
        i18n.t('planningPage.positionsNotAssigned').toString(),
        employeeEventList,
        '',
        '',
        '',
        '#000',
        ''
      )
    }
  }

}
